import "./Footer.css";
import logo from "../pics/logo.png";
import MyVerticallyCenteredModal from "../pages/Contact";
import React from "react";



function Footer() {
  const linkedinlink = "https://www.linkedin.com/in/ankit-kumar-709b99162/";
  const githublink = "https://github.com/ank-2222";
  const [modalShow, setModalShow] = React.useState(false);


  return (
    <div className="footer">
      <div className="d-flex justify-content-center">
        <a href="#home-main">
          <img className="footer-logo" src={logo}></img>
        {/* <span className="top">Top</span> */}

        </a>
      </div>
      <div>
        <ul className="footer-link">
          <li>
            <button className="contact-btn" onClick={() => setModalShow(true)}>Contact</button>
          </li>
          <li>
            <a target="_blank" href={linkedinlink}>
              LinkedIn
            </a>
          </li>
          <li>
            <a target="_blank" href={githublink}>
              GitHub
            </a>
          </li>
        </ul>

        <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      </div>
     
    </div>
  );
}

export default Footer;
